module.exports = {"member":"Hodor","collaborator":"Hodor","moderator":"Hodor","admin":"Hodor"};